import { loadImgXHR } from "@/components/ZkImg/src/load.js";
import numeral from "numeral";

function removeClass(els, className) {
  let doms = [];
  if (!els.length) {
    doms.push(els);
  } else {
    doms = els;
  }
  for (let item, i = 0; i < doms.length; i++) {
    item = doms[i];
    if (item.className) {
      let newClass = item.className.split(" ");
      if (hasClass(item, className)) {
        newClass = newClass.filter(clz => {
          return clz !== className;
        });
        item.className = newClass.join(" ");
      }
    }
  }
}

function addClass(el, className) {
  if (hasClass(el, className)) {
    return;
  }
  let newClass = el.className.split(" ");
  newClass.push(className);
  el.className = newClass.join(" ");
}

function hasClass(el, className) {
  let reg = new RegExp("(^|\\s)" + className + "(\\s|$)");
  return reg.test(el.className);
}

function toggleClass(el, className) {
  if (hasClass(el, className)) {
    removeClass(el, className);
  } else {
    addClass(el, className);
  }
}

function getDomHeight(nHd, nFd) {
  let docEl = window.document.documentElement,
    winH = window.screen.height,
    fontSize = parseFloat(
      window.getComputedStyle(window.document.documentElement)["font-size"]
    );
  if (nHd && nFd) {
    return winH - fontSize * 2.2 - fontSize * 2.4;
  } else if (nHd) {
    return winH - fontSize * 2.2;
  } else if (nFd) {
    return winH - fontSize * 2.4;
  } else {
    return winH;
  }
}

function copyText(text) {
  var container = document.body;

  var isRTL = document.documentElement.getAttribute("dir") == "rtl";

  var copyDom = document.getElementsByClassName("copyDom");
  if (copyDom && copyDom.length > 0) {
    container.removeChild(copyDom[0]);
  }
  var fakeElem = document.createElement("textarea");
  // Prevent zooming on iOS
  fakeElem.style.fontSize = "12pt";
  // Reset box model
  fakeElem.style.border = "0";
  fakeElem.style.padding = "0";
  fakeElem.style.margin = "0";
  // Move element out of screen horizontally
  fakeElem.style.position = "absolute";
  fakeElem.style[isRTL ? "right" : "left"] = "-9999px";
  // Move element to the same position vertically
  var yPosition = window.pageYOffset || document.documentElement.scrollTop;
  fakeElem.style.top = yPosition + "px";

  fakeElem.setAttribute("readonly", "");
  fakeElem.className = "copyDom";
  fakeElem.value = text;
  container.appendChild(fakeElem);
  fakeElem.select();
  fakeElem.setSelectionRange(0, fakeElem.value.length);

  window.selectedText = fakeElem.value;
  var succeeded = void 0;

  try {
    succeeded = document.execCommand("copy");
  } catch (err) {
    succeeded = false;
  }
  return succeeded;
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function(...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

async function drag(dom, option) {
  await dom;
  let w,
    h,
    x,
    y,
    souceX,
    souceY,
    disX,
    disY,
    winH = document.documentElement.clientHeight,
    winW = document.documentElement.clientWidth;
  let {
    disTop = 40,
    disBottom = 40,
    domH = 0,
    leftCallBack,
    rightCallBack
  } = option;
  if (!dom) return;
  dom.style.left = winW - dom.clientWidth + "px";

  dom.addEventListener("touchstart", event => {
    removeClass(dom, "drag-animate");
    let touch = event.touches[0]; //获取第一个触点
    souceX = touch.clientX;
    souceY = touch.clientY;
    x = dom.offsetLeft;
    y = dom.offsetTop;
  });
  dom.addEventListener("touchmove", event => {
    let touch = event.touches[0],
      top; //获取第一个触点
    w = dom.clientWidth;
    h = domH || dom.clientHeight;
    disX = touch.clientX - souceX;
    disY = touch.clientY - souceY;
    top = y + disY;
    if (top > winH - h - disBottom) {
      top = winH - h - disBottom;
    } else if (top < disTop) {
      top = disTop;
    }
    dom.style.top = top + "px";
    dom.style.left = x + disX + "px";
    try {
      event.preventDefault();
    } catch (error) {}
  });
  dom.addEventListener("touchend", event => {
    let touch = event.touches[0],
      style = dom.style; //获取第一个触点
    w = dom.clientWidth;
    addClass(dom, "drag-animate");
    if (!style.left || parseFloat(style.left) >= winW / 2 - w / 2) {
      style.left = winW - w + "px";
      leftCallBack && leftCallBack();
    } else {
      style.left = 0;
      rightCallBack && rightCallBack();
    }
  });
}

function escapeHtml(str) {
  if (!str) return "";
  var arrEntities = {
    lt: "<",
    gt: ">",
    nbsp: " ",
    amp: "&",
    quot: '"'
  };
  return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function(all, t) {
    return arrEntities[t];
  });
}

/**
 * 倒计时
 * @param {string} diffTime 时间戳之差
 */
function countDown(diffTime) {
  let vm = this;
  let obj = {};
  let days = Math.floor(diffTime / (24 * 3600 * 1000));
  //计算出小时数
  let leave1 = diffTime % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
  obj.hours = Math.floor(leave1 / (3600 * 1000)) + days * 24;
  //计算相差分钟数
  let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
  obj.minutes = Math.floor(leave2 / (60 * 1000));
  //计算相差秒数
  let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
  obj.seconds = Math.round(leave3 / 1000);
  ["hours", "minutes", "seconds"].forEach(item => {
    if (obj[item] < 10) obj[item] = "0" + obj[item];
  });
  return obj.hours + ":" + obj.minutes + ":" + obj.seconds;
}
/***
 * 计算汉字个数
 * @param {string} fData 需要计算的数据
 */
function DataLength(fData) {
  var intLength = 0;
  for (var i = 0; i < fData.length; i++) {
    if (fData.charCodeAt(i) < 0 || fData.charCodeAt(i) > 255)
      intLength = intLength + 2;
    else intLength = intLength + 1;
  }
  return intLength;
}
/***
 * 获取元素位置信息
 * @param {string} el 需要获取位置信息的元素
 */
export function getRect(el) {
  return {
    top: el.offsetTop,
    left: el.offsetLeft,
    width: el.offsetWidth,
    height: el.offsetHeight
  };
}
const inBrowser = typeof window !== "undefined";
let vendor = (() => {
  /* istanbul ignore if */
  if (!inBrowser) {
    return false;
  }
  let elementStyle = document.createElement("div").style;
  let transformNames = {
    standard: "transform",
    webkit: "webkitTransform",
    Moz: "MozTransform",
    O: "OTransform",
    ms: "msTransform"
  };

  for (let key in transformNames) {
    if (elementStyle[transformNames[key]] !== undefined) {
      return key;
    }
  }

  /* istanbul ignore next */
  return false;
})();
const u = navigator.userAgent;
var browser = {
  trident: u.indexOf("Trident") > -1, //IE内核
  presto: u.indexOf("Presto") > -1, //opera内核
  webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
  gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
  mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
  ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
  android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, //android终端
  iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
  iPad: u.indexOf("iPad") > -1, //是否iPad
  webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
  weixin: u.indexOf("MicroMessenger") > -1, //是否微信 （2015-01-22新增）
  qq: u.match(/\sQQ/i) == " qq" //是否QQ
};

function loadEwmUrl() {
  return new Promise((resolve, reject) => {
    loadImgXHR(
      "/api/v2/user/captcha.jpg?d=" + new Date().getTime(),
      (url, headers) => {
        if (headers) {
          const m = headers.match(/^kaptchaflag\:\s*(.*?)$/im);
          let kaptchaFlag = "";
          if (m && m[1]) {
            kaptchaFlag = m[1];
          }
          resolve({ url, kaptchaFlag });
        }
      },
      () => {}
    );
  });
}

export function uuid() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (
    S4() + S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4()
  );
}

function getVersionView(viewName) {
  const { version } = window.configText;
  return version ? viewName + version : viewName;
}

export function createObjectURL(blob) {
  return window[window.webkitURL ? "webkitURL" : "URL"]["createObjectURL"](
    blob
  );
}

/**
 * 格式化数字
 * @param  {[string | number]} number  [要格式化的数字]
 * @param  {[number]} decimals         [保留几位小数]
 * @param  {[string]} decPoint        [小数点符号]
 * @param  {[string]} thousands_sep    [千分位符号]
 * @param  {[string]} roundtag         [舍入参数，默认 "ceil" 向上取,"floor"向下取,"round" 四舍五入]
 * @return {[string]} 格式化后的结果
 */
function numberFormat(
  number = 0,
  decimals = 2,
  roundtag = "floor",
  decPoint = ".",
  thousandSep = ""
) {
  number = (number + "").replace(/[^0-9+-Ee.]/g, "");
  roundtag = roundtag || "floor"; //"ceil","floor","round"
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousandSep === "undefined" ? "," : thousandSep,
    dec = typeof decPoint === "undefined" ? "." : decPoint,
    s = "",
    toFixedFix = function(n, prec) {
      var k = Math.pow(10, prec);
      return (
        "" +
        parseFloat(
          Math[roundtag](parseFloat((n * k).toFixed(prec * 2))).toFixed(
            prec * 2
          )
        ) /
          k
      );
    };
  s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
  if (sep) {
    var re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
      s[0] = s[0].replace(re, "$1" + sep + "$2");
    }
  }
  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
}

const supportCss3 = style => {
  let prefix = ["webkit", "Moz", "ms", "o"],
    i,
    humpString = [],
    htmlStyle = document.documentElement.style,
    _toHumb = function(string) {
      return string.replace(/-(\w)/g, ($0, $1) => $1.toUpperCase());
    };

  for (i in prefix) {
    humpString.push(_toHumb(`${prefix[i]}-${style}`));
  }

  humpString.push(_toHumb(style));

  for (i in humpString) {
    if (humpString[i] in htmlStyle) return prefix[i] || true;
  }

  return false;
};

const isImgType = fileName => {
  if (/\.(gif|jpg|jpeg|png)$/gim.test(fileName)) {
    return true;
  }
  return false;
};

const isGifType = fileName => {
  if (/\.(gif)$/gim.test(fileName)) {
    return true;
  }
  return false;
};

const getMimeTypeByUrl = (url = "") => {
  if (url) {
    const type = url.match(/\.{1}([a-z]*)\?/)[1] || "png";
    return `image/${type}`;
  }
  return `image/png`;
};

const joinBase64Head = (mimeType, content) => {
  return `data:${mimeType};base64,${content}`;
};

const validDataUrl = s => {
  const regex = /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*?)\s*$/i;
  const regex2 = /^\s*blob:([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*?)\s*$/i;
  return regex.test(s) || regex2.test(s);
};

function isPositive(value) {
  return !(numeral(value).value() < 0);
}

export default {
  isPositive: isPositive,
  removeClass: removeClass,
  addClass: addClass,
  hasClass: hasClass,
  getDomHeight: getDomHeight,
  toggleClass: toggleClass,
  copyText: copyText,
  debounce: debounce,
  drag: drag,
  DataLength: DataLength,
  countDown: countDown,
  browser,
  createObjectURL,
  loadEwmUrl: loadEwmUrl,
  getVersionView,
  numberFormat,
  supportCss3,
  isImgType,
  isGifType,
  getMimeTypeByUrl,
  joinBase64Head,
  validDataUrl,
  escapeHtml
};
